<div class="empty-chat-message-wrapper">
  <div class="empty-chat-message-container">
    <div class="empty-chat-message-title">{{ polarisName }}</div>
    <div class="empty-chat-message-content">
      <p class="empty-chat-message-headline">Message failed to send</p>
      <p>We couldn't send your message due to a temporary issue. It wasn't saved in this chat.</p>
      <p>Please try again.</p>
    </div>
  </div>
</div>
